import { ErrorHandler, Injectable } from '@angular/core';
import { MessageProvider } from './message.provider';

@Injectable()
export class CnesErrorHandler extends ErrorHandler {

    constructor(
        private messageProvider: MessageProvider
    ) {
        super();
    }

    // Requisições disparadas em segundo plano, que não iniciam loading: se falharem, não devem fechar o loading
    // de uma operação que esteja em andamento na tela.
    private static readonly URLS_SEM_LOADING = ['/notificacao/nao-lidas'];

    handleError(error: any): void {
        console.log(error);
        console.error(error);
        console.trace();
        let mensagem: string;
        if (error.rejection) {
            error = error.rejection;
        }

        if (this.erroDeRequisicaoSemLoading(error)) {
            return;
        }

        if (error instanceof Error) {
            mensagem = error.message.toString();
        } else {
            mensagem = error.message || error.toString();
        }

        setTimeout(async () => {
            await this.messageProvider.dismissLoading();
            //await this.messageProvider.showToast(mensagem);
        }, 10);
    }

    private erroDeRequisicaoSemLoading(error: any): boolean {
        const url: string = error && typeof error.url === 'string' ? error.url : '';
        return CnesErrorHandler.URLS_SEM_LOADING.some(trecho => url.includes(trecho));
    }

}
